import React, { useState, useRef, useEffect, useContext } from 'react';
import { FaDotCircle, FaHome, FaPuzzlePiece} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { LanguageContext } from '@lib/i18n/LanguageProvider';

interface MenuProps {
    activePage: string;
    toggleMenu: () => void;
}

const Menu: React.FC<MenuProps> = ({ activePage, toggleMenu }) => {
    const context = useContext(LanguageContext);
    const { translations = {}, lang = 'tr-TR' } = context || {};

    const [showDevPages, setShowDevPages] = useState<boolean>(true);

    const [openMenu, setOpenMenu] = useState<string | null>(null);
    const menu1Ref = useRef<HTMLUListElement>(null);
    const isActive = (page: string) => (activePage === page ? 'text-primary' : '');
    const isMenu1Active = ['Menu1Elem1', 'Menu1Elem2'].includes(activePage);
    const handleMenuToggle = (menuName: string) => {
        setOpenMenu(openMenu === menuName ? null : menuName);
    };

    useEffect(() => {
        const menuRefs = {
            menu1: menu1Ref,
        };

        Object.keys(menuRefs).forEach((menuName) => {
            const ref = menuRefs[menuName as keyof typeof menuRefs].current;
            if (ref) {
                if (openMenu === menuName) {
                    ref.style.height = `${ref.scrollHeight}px`;
                    ref.style.overflow = 'hidden';
                } else {
                    ref.style.height = '0px';
                }
            }
        });
    }, [openMenu]);

    return (
        <ul className="nav flex-column">
            {showDevPages &&
                <li className="nav-item">
                    <a
                        className={`nav-link ${openMenu === 'menu1' || isMenu1Active ? 'active text-primary' : 'collapsed'}`}
                        onClick={() => handleMenuToggle('menu1')}
                        href="#"
                    >
                        <FaDotCircle />
                        <span className="item-name">
                            DevTools
                        </span>
                        <i
                            className="right-icon"
                            style={{
                                transform: openMenu === 'menu1' ? 'rotate(90deg)' : 'rotate(0deg)',
                                transition: 'transform 0.3s ease',
                            }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" className="icon-18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
                            </svg>
                        </i>
                    </a>

                    <ul
                        ref={menu1Ref}
                        className={`sub-nav ${openMenu === 'menu1' ? 'show' : ''}`}
                        style={{ height: '0px', overflow: 'hidden', transition: 'height 0.3s ease' }}
                    >

                        <li className="nav-item">
                            <Link
                            className={`nav-link ${isActive('DevIndex')}`}
                            to={`/${lang}/Dev/DevIndex`}
                            onClick={toggleMenu}
                            >
                                <FaHome />
                                <span className={"item-name"}>
                                    {translations['index']}
                                </span>
                            </Link>
                        </li>

                        <li className="nav-item">
                            <Link
                            className={`nav-link ${isActive('Components')}`}
                            to={`/${lang}/Dev/Components`}
                            onClick={toggleMenu}>
                                <FaPuzzlePiece />
                                <span className={"item-name"}>
                                    {translations['components']}
                                </span>
                            </Link>
                        </li>

                        <li className="nav-item">
                            <Link
                            className={`nav-link ${isActive('ComponentTest')}`}
                            to={`/${lang}/Dev/ComponentTest`}
                            onClick={toggleMenu}>
                                <FaPuzzlePiece />
                                <span className={"item-name"}>
                                    {translations['component-test']}
                                </span>
                            </Link>
                        </li>

                    </ul>
                </li>
            }
        </ul>
    );
};

export default Menu;
